/**
 * Renders a user chat bubble body. When `segments` are present (chips + text
 * from the TipTap composer), walks them and renders chips as pills inline
 * with the text runs. Falls back to plain preformatted text for legacy
 * messages that predate the segments column.
 */
import type { ChatSegment } from "./ChatComposerEditor";
import { CorpusChipPill } from "./CorpusChipPill";

export const UserMessageBody = ({
  segments,
  fallbackText,
}: {
  segments: ChatSegment[] | null | undefined;
  fallbackText: string;
}) => {
  if (!segments || segments.length === 0) {
    return <p className="whitespace-pre-wrap">{fallbackText}</p>;
  }
  return (
    <p className="whitespace-pre-wrap leading-6">
      {segments.map((seg, i) => {
        if (seg.type === "chip") {
          return (
            <span key={`chip-${i}`} className="align-baseline">
              <CorpusChipPill kind={seg.kind} label={seg.label} />
            </span>
          );
        }
        return <span key={`t-${i}`}>{seg.text}</span>;
      })}
    </p>
  );
};
